import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'

import WalletTabs from '../../components/profile/wallet/WalletTabs'
import WalletTable from '../../components/profile/wallet/walletTable/WalletTable'
import PageHeader from '../../components/profile/pageHeader'
import WalletDescription from '../../components/profile/wallet/WalletDescription'

import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { checkAuth, loadMember } from '../../utils/auth'
import paths from '../../paths'
import './wallet.sass'

const WalletHistory = () => {
    const [t] = useTranslation()
    const location = useLocation()

    const { user, savedGifts } = useSelector((state: RootState) => state.member)

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.myWallet[getLangFromPath(location.pathname)].title}</title>
                <meta name="description" content={META.myWallet[getLangFromPath(location.pathname)].description} />
            </Helmet>
            <div className="pageRow">
                <PageHeader user={user} text={t('My wallet')} self />
            </div>
            <WalletTabs amountOfGifts={savedGifts.length} />
            <WalletDescription />
            <WalletTable />
        </div>
    )
}

//@ts-ignore
WalletHistory.getInitialProps = async ({ req, store }) => {
    if (req) {
        await checkAuth(store)
        const {
            member: { loggedIn }
        } = store.getState()

        if (loggedIn) {
            await loadMember(store)
        } else {
            return {
                redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.myWallet.path}`
            }
        }
    }
}

export default WalletHistory
